import { render, staticRenderFns } from "./user_coin_log.vue?vue&type=template&id=21137c5c&scoped=true&"
import script from "./user_coin_log.vue?vue&type=script&lang=js&"
export * from "./user_coin_log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21137c5c",
  null
  
)

export default component.exports